function ChoosePickupOption() {
  return (
    <>

      <p>

        <span style={{ color: "rgb(51, 51, 51)", fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          We do recommend our pick up option for delicate items such as bulbs,
          assemblies and glass components, to lower any risk of damage, as well
          as very heavy or over-sized items that may take extra long to ship to
          your home. P
        </span>

        <span style={{ color: "rgb(51, 51, 51)", fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          Pick up service is faster by a day or more, than shipping parts to
          your home
        </span>
      </p>

      <p>

        <span style={{ color: "rgb(51, 51, 51)", fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
          If you are located close to our pick up location, you can come to our
          warehouse in our working hours Mon-Fri, after you receive the
          confirmations SMS. You can also do returns at our pickup locations for
          any faulty parts.
        </span>
      </p>
    </>
  );
}

export default ChoosePickupOption;
